<template>
  <c-select
    hide-details
    :items="getLocales"
    :model-value="locale"
    item-title="label"
    item-value="value"
    :height="36"
    :menu-props="{
      contentClass: 'lang-menu',
      location: 'top',
      offset: 5
    }"
    bg-color="secondary-800"
    append-icon-color="secondary-400"
    @update:model-value="setLocale($event)"
  >
    <template #selection="{ item }">
      <v-icon :size="20">
        {{ item.raw.flagIcon }}
      </v-icon>
      <div v-if="!isMiniSidebarShown" class="text-white ml-3 text-subtitle-1">
        {{ item.raw.label }}
      </div>
    </template>
    <template #item="{ item, props }">
      <v-list-item v-bind="props" rounded="lg" class="text-white text-subtitle-1">
        <template #prepend>
          <v-icon>{{ item.raw.flagIcon }}</v-icon>
        </template>
      </v-list-item>
    </template>
  </c-select>
</template>

<script>
  import { mapActions, mapState } from 'pinia'
  import { CSelect } from '@clickadilla/components/components'
  import { useSettingsStore } from '@/store/settings/settings'
  import { personalRepository } from '@/services/repository-factory'
  import { loadLanguageAsync } from '@/i18n'

  export default {
    name: 'LanguageSelect',
    components: { CSelect },
    computed: {
      ...mapState(useSettingsStore, ['isMiniSidebarShown', 'locale', 'getLocales'])
    },
    watch: {
      locale: {
        immediate: true,
        async handler(newLocale) {
          await this.$auth.fetchUser()
          const userLocale = this.$auth.user?.locale
          if (userLocale !== newLocale) {
            await personalRepository.setLocale(newLocale)
            loadLanguageAsync(newLocale, this.$route.meta.localeFiles)
            await this.$auth.refresh()
            await this.fetchSettings(this.$auth.isAuth)
          }
        }
      }
    },
    methods: {
      ...mapActions(useSettingsStore, ['setLocale', 'fetchSettings'])
    }
  }
</script>

<style lang="scss">
.lang-menu {
  &.v-overlay__content {
    box-shadow: none !important;
    border: 1px solid rgb(var(--v-theme-secondary-800));
  }
  .v-list {
    --v-list-prepend-gap: 12px;

    background-color: rgb(var(--v-theme-black));
    padding: 4px 8px;

    .v-ripple__container {
      display: none !important;
    }

    &-item {
      margin: 4px 0;
      overflow: hidden;
      min-height: 36px;

      .v-list-item__overlay {
        display: none;
      }

      &:hover {
        background-color: color-mix(
          in srgb,
          rgb(var(--v-theme-secondary-800)) 60%,
          transparent
        );
      }

      &--active,
      &:active {
        background-color: rgb(var(--v-theme-secondary-800)) !important;
      }
    }
  }
}
</style>
